import React from 'react';
import {NavLink} from 'react-router-dom';
import homeIcon from "../../public/assets/images/home.png";
import ogwIcon from "../../public/assets/images/ogw.png";
import compAudit from "../../public/assets/images/comp_audit.png";
import kpiListIcon from "../../public/assets/images/kpi.png";
import jobIcon from "../../public/assets/images/job.png";
import dataIcon from "../../public/assets/images/staff_data.png";
import compIcon from "../../public/assets/images/profile.png";


const BodyNav = (props) => {
    const {selectedMenu} = props;

    return (
        <div className="container-fluid body-menu-bar">
            <ul className="body-menu d-flex justify-content-around">
                <li className={`${selectedMenu === 'home' && 'active'}`}>
                    <NavLink to="/home">
                        <div className="body-menu-icon">
                            <img src={homeIcon} />
                        </div>
                        Home
                    </NavLink>
                </li>
                <li className={`${selectedMenu === 'ogw' && 'active'}`}>
                    <NavLink to='/organic-growth-wizard'>
                        <div className="body-menu-icon">
                            <img src={ogwIcon} />
                        </div>
                        Organic Growth Calculator
                    </NavLink>
                </li>
                <li className={`${selectedMenu === 'compAudit' && 'active'}`}>
                    <NavLink to='/compliance-audit'>
                        <div className="body-menu-icon">
                            <img src={compAudit} />
                        </div>
                        Compliance Review
                    </NavLink>
                </li>
                <li className={`${selectedMenu === 'jobDesc' && 'active'}`}>
                    <NavLink to='/job-description'>
                        <div className="body-menu-icon">
                            <img src={jobIcon} />
                        </div>
                        Job Descriptions
                    </NavLink>
                </li>
                <li className={`${selectedMenu === 'kpi' && 'active'}`}>
                    <NavLink to='/kpi'>
                        <div className="body-menu-icon">
                            <img src={kpiListIcon} />
                        </div>
                        Master KPI List
                    </NavLink>
                </li>
                <li className={`${selectedMenu === 'staffData' && 'active'}`}>
                    <NavLink to='/staff-data'>
                        <div className="body-menu-icon">
                            <img src={dataIcon} />
                        </div>
                        Staff Data
                    </NavLink>
                </li>
                <li className={`${selectedMenu === 'compProfile' && 'active'}`}>
                    <NavLink to='/compensation-profile'>
                        <div className="body-menu-icon">
                            <img src={compIcon} />
                        </div>
                        Compensation Profiles
                    </NavLink>
                </li>
            </ul>
        </div>
    );
}

export default BodyNav;



// WEBPACK FOOTER //
// ./src/components/nav/BodyNav.js